var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Button, TextField } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Controller, useForm } from 'react-hook-form';
const useStyles = makeStyles((theme) => {
    return ({
        root: {},
        alert: {
            marginBottom: theme.spacing(2),
        },
        fields: {
            margin: theme.spacing(-1),
            display: 'flex',
            flexWrap: 'wrap',
            '& > *': {
                flexGrow: 1,
                margin: theme.spacing(1),
            },
        },
        submitButton: {
            marginTop: theme.spacing(2),
            width: '100%',
        },
    });
});
export const LoginForm = props => {
    const { className, onSubmit } = props, rest = __rest(props, ["className", "onSubmit"]);
    const { handleSubmit, control, formState: { isValid } } = useForm({
        shouldFocusError: false,
        shouldUnregister: false,
        mode: 'onChange',
        reValidateMode: 'onChange',
    });
    const classes = useStyles();
    const [loginError, setLoginError] = useState(false);
    const login = (data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield onSubmit(data);
            setLoginError(false);
        }
        catch (e) {
            // Login Error
            setLoginError(true);
        }
    });
    return (React.createElement("form", Object.assign({}, rest, { className: clsx(classes.root, className), onSubmit: handleSubmit(login) }),
        loginError && React.createElement(Alert, { className: classes.alert, severity: "error" },
            React.createElement(AlertTitle, null, "La connexion a \u00E9chou\u00E9"),
            "V\u00E9rifiez le couple email/mot de passe !"),
        React.createElement("div", { className: classes.fields },
            React.createElement(Controller, { name: "email", rules: { required: true }, control: control, render: ({ field, fieldState }) => {
                    return React.createElement(TextField, Object.assign({ error: fieldState.invalid, fullWidth: true, helperText: fieldState.invalid ? "Le mail est requis" : null, label: "Adresse e-mail", variant: "outlined", required: true }, field));
                } }),
            React.createElement(Controller, { name: "password", rules: { required: true }, control: control, render: ({ field, fieldState }) => {
                    return React.createElement(TextField, Object.assign({ error: fieldState.invalid, fullWidth: true, helperText: fieldState.invalid ? "Le mail est requis" : null, label: "Mot de passe", type: "password", variant: "outlined", required: true }, field));
                } })),
        React.createElement(Button, { className: classes.submitButton, color: "secondary", disabled: !isValid, size: "large", type: "submit", variant: "contained" }, "Connexion")));
};
//# sourceMappingURL=LoginForm.js.map